export class RulesConfigDescriptionLocalizable {
    static WIDTH = () => $localize `Width`;
    static HEIGHT = () => $localize `Height`;
    static SIZE = () => $localize `Size`;
    static ALIGNMENT_SIZE = () => $localize `Number of aligned pieces needed to win`;
    static NUMBER_OF_DROPS = () => $localize `Number of pieces dropped per turn`;
    static NUMBER_OF_EMPTY_ROWS = () => $localize `Number of empty rows`;
    static NUMBER_OF_PIECES_ROWS = () => $localize `Number of pieces rows`;
    static TORIC = () => $localize `Toric`;
}
